import LevelABrevetSticker from "../../stickers/levelAScreen/LevelABrevetSticker";
import LevelASubthemeDescriptionDialog from "../../dialogs/levelAScreen/LevelASubthemeDescriptionDialog";
import {useState} from "react";
import LevelAInfoButton from "../../buttons/levelAScreen/LevelAInfoButton";
import {isNullOrUndefined} from "../../../services/Validator";
import {get_nested} from "../../../services/JsonHandler";
import LevelATaskText from "../../texts/levelAScreen/LevelATaskText";
import LevelAMetaDataGradeNameText from "../../texts/levelAScreen/LevelAMetaDataGradeNameText";
import LevelAMetaDataThemeNameText from "../../texts/levelAScreen/LevelAMetaDataThemeNameText";
import LevelAMetaDataSubthemeNameText from "../../texts/levelAScreen/LevelAMetaDataSubthemeNameText";

export default function LevelAMetaData({task, brevet, levelAGrade, levelASubtheme}) {
    // Used in LevelAContent to display meta data

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    const subthemeName = get_nested(['name'], levelASubtheme, null)
    const subthemeDescription = get_nested(['shortDescription'], levelASubtheme, null)

    // BUILD
    return (
        <div className={"w-full flex flex-col space-y-[4px] justify-start items-start"}>
            {/** MODAL */}
            <LevelASubthemeDescriptionDialog open={isModalOpen}
                                             handleClose={() => setIsModalOpen(false)}
                                             name={subthemeName}
                                             description={subthemeDescription} />
            {/** CONTENT */}
            <div className={"w-full flex justify-start items-start"}>
                <LevelATaskText task={task} />
                <LevelABrevetSticker isForBrevet={brevet} />
            </div>
            <div className={"w-full flex space-x-[4px] justify-start items-center text-greyLight7 font-medium"}>
                <LevelAMetaDataGradeNameText name={levelAGrade?.name} />
                <LevelAMetaDataThemeNameText name={levelASubtheme?.subthemeTheme?.name} />
                <LevelAMetaDataSubthemeNameText name={levelASubtheme?.name} />
                <LevelAInfoButton displayButton={!isNullOrUndefined(subthemeDescription)}
                                  onClick={() => setIsModalOpen(true)} />
            </div>
        </div>
    );
}